
<div
  class="icon-wrapper"
  :class="{ thin: strokeWidth === 'thin', thick: strokeWidth === 'thick', thicker: strokeWidth === 'thicker' }"
  @click="$emit('click', $event)"
>
  <IconifyIcon :icon="icon" :width="_iconWidth" :height="_iconWidth" :rotate="rotate"></IconifyIcon>
</div>
